const wrapperCls = "c2lw14nmodr";
const transitionDurationMs = 250;
const transitionCls = "c2lt1ysyr6y";
const headingCls = "c2lh1l0fqpi";
const scrollGradientCls = "c2ls1h8jlj2";
const buttonWrapperCls = "c2lblemmnj";
const buttonCls = "c2lbh4kiy1";
const plusCls = "c2lpkq0q8v";

export { buttonCls, buttonWrapperCls, headingCls, plusCls, scrollGradientCls, transitionCls, transitionDurationMs, wrapperCls };
import "./_overview.style.linaria.module.css";
//# sourceMappingURL=_overview.style.js.map
